import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SiteContext = createContext({ settings: null, nav: [], announcements: [], ctas: [], reload: () => {} });

export function SiteProvider({ children }) {
  const [state, setState] = useState({ settings: null, nav: [], announcements: [], ctas: [], footerSections: [], seo: [] });
  const reload = useCallback(async () => {
    const [s, n, a, c, f, seo] = await Promise.all([
      axios.get(`${API}/site/settings`), axios.get(`${API}/cms/nav`), axios.get(`${API}/cms/announcements`), axios.get(`${API}/cms/ctas`), axios.get(`${API}/cms/footer_sections`), axios.get(`${API}/cms/seo`),
    ]);
    setState({ settings: s.data, nav: n.data, announcements: a.data, ctas: c.data, footerSections: f.data, seo: seo.data });
  }, []);
  useEffect(() => { reload().catch(() => {}); }, [reload]);
  useEffect(() => {
    const s = state.settings; if (!s) return;
    const link = document.querySelector("link[rel~='icon']"); if (link && s.favicon_url) link.href = s.favicon_url;
  }, [state.settings]);
  return <SiteContext.Provider value={{ ...state, reload }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
export const cta = (ctas, key, fallback) => { const c = (ctas || []).find((x) => x.key === key); return c || fallback; };
